/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusErlassDetailDto } from '../../models/lexplus-erlass-detail-dto';

export interface ErlassDetailControllerGetErlassDetailV1$Params {
  erlassID: number;
}

export function erlassDetailControllerGetErlassDetailV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerGetErlassDetailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusErlassDetailDto>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerGetErlassDetailV1.PATH, 'get');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusErlassDetailDto>;
    })
  );
}

erlassDetailControllerGetErlassDetailV1.PATH = '/v1/compliance/erlasse/{erlassID}';
